import React, {useEffect} from 'react';
import {
  Popover as ChakraPopover,
  PopoverTrigger,
  PopoverProps as ChakraPopoverProps,
  useDisclosure,
} from '@chakra-ui/react';
import PopoverContent from './PopoverContent';

interface PopoverProps extends ChakraPopoverProps {
  triggerElement: JSX.Element;
  header: string;
  content: JSX.Element;
  openDisabled?: boolean;
  topRightElement?: JSX.Element;
}

const Popover = ({
  triggerElement,
  header,
  content,
  openDisabled,
  topRightElement,
  ...rest
}: PopoverProps) => {
  // close the popover when navigating to a new page
  useEffect(() => {
    rest.onClose && rest.onClose();
  }, [location.href]);

  return (
    <ChakraPopover {...rest}>
      <PopoverTrigger>{triggerElement}</PopoverTrigger>
      <PopoverContent header={header} body={content} topRightElement={topRightElement} />
    </ChakraPopover>
  );
};

export default Popover;
